module.exports = __webpack_public_path__ + "img/progress-two-done.708ce2ad.png";